import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './Layout.module.css';
import Navigation from './Navigation';
import useMediaQuery from '../../hooks/useMediaQuery';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const navigate = useNavigate();
  const isMobile = useMediaQuery('(max-width: 768px)');

  // Desktop layout with sidebar
  if (!isMobile) {
    return (
      <div className={styles.layout}>
        <aside className={styles.sidebar}>
          <div className={styles.sidebarHeader}>
            <h1 
              className={styles.title} 
              onClick={() => navigate('/')}
            >
              Organizer
            </h1>
          </div>
          <div className={styles.sidebarContent}>
            <Navigation />
          </div>
        </aside>
        <main className={styles.main}>
          {children}
        </main>
      </div>
    );
  }

  // Mobile layout without a persistent header
  return (
    <div className={styles.layout}>
      <Navigation />
      <main className={styles.main}>
        {children}
      </main>
    </div>
  );
};

export default Layout;
